import { ProductCertificationUpdateInterface } from './../../../../../model/product-certification/product-certification-update-interface';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ProductCertificationOverview } from 'src/app/model/product-certification/product-certification-overview';
import { Router } from '@angular/router';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { CertificationVariantService } from 'src/app/services/dataServices/certification-variant-service/certification-variant-service';
import { CertificationVariantVersionService } from 'src/app/services/dataServices/cetrification-variant-version-service/certification-variant-version-service';
import { ProductMinimalInterface } from 'src/app/model/products/product-minimal-interface';
import { ProductCertificationService } from 'src/app/services/product-certification-service/product-certification.service';
import { OrganisationMinimalInterface } from 'src/app/model/organisations/organisation-minimal-interface';
import { UserService } from 'src/app/services/user-service/userservice';
import { ProductCategory } from 'src/app/model/enums/productCategory';
import { DatePipe } from '@angular/common';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { OrganisationOntologyOverviewInterface } from 'src/app/model/organisations/organisation-ontology-overview-interface';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { firstValueFrom } from 'rxjs';
import {
    CredentialLifecycleStatus,
    IssuerOrganisationAttestationWorkflow,
    JsonObject,
    JsonValue
} from 'src/app/construct-x/data-space/models/issuer-api.models';
import { IssuerCertificationCatalogueApiService } from 'src/app/construct-x/data-space/services/issuer-certification-catalogue-api.service';
import { CertificateValueNode } from '../../certifications/certification-template-editor/template-value-node-editor/template-value-node-editor.component';

@Component({
    selector: 'app-certification-variant-version-manage-screen',
    templateUrl: './cert-verrsion-manage-screen.component.html',
    styleUrls: ['./cert-verrsion-manage-screen.component.scss'],
    standalone: false
})
export class CertVersionManageScreenComponent implements OnInit, OnDestroy {
    public overviewList: ProductCertificationOverview[] = [];
    public productList: ProductMinimalInterface[] = [];
    public orgaList: OrganisationMinimalInterface[] = [];
    public certifiedOrganisationsForOntology: OrganisationOntologyOverviewInterface[] = [];

    // list of products that already have the current certification, used for the pagination
    public certifiedProductPage: ProductCertificationOverview[] = [];
    public certifiedNonListedProductPage: ProductCertificationOverview[] = [];
    public selectedProduct: number;
    public productCertificationUpdateList: ProductCertificationUpdateInterface[] =
        [];
    public selectedOrganisation: number;

    public productname: string;
    public orgaName: string;
    public productVariant: string;
    public productVariantVersion: string;
    public emailofOrga: string;
    public validated: boolean;
    public productType: ProductCategory[] = [
        ProductCategory.Software,
        ProductCategory.SpecPub,
        ProductCategory.database
    ];
    public prodType: ProductCategory;
    public undefinedVariable: string;
    public error: boolean;
    public showNonListedProdCert: boolean;
    public toggleOrganisationSwitch: boolean;
    certType: string | number;
    certShape: string | null;
    certificateValuesJson = '';
    public issuerOrganisations: OrganisationInterface[] = [];
    public issuerWorkflows: IssuerOrganisationAttestationWorkflow[] = [];
    public issuerLoading = false;
    public issuerError = '';

    statusMapping = {
        'IN_BEARBEITUNG': 'In Bearbeitung',
        'AKTIV': 'Aktiv',
        'ABGELAUFEN': 'Abgelaufen',
        'ZURUECKGEZOGEN': 'Zurückgezogen',
        'ANGEFRAGT': 'Angefragt',
        'ABGELEHNT': 'Abgelehnt'
    };

    constructor(
        private router: Router,
        private organisationService: OrganisationService,
        private certificationService: CertificationService,
        private certificationVariantService: CertificationVariantService,
        private certificationVariantVersionService: CertificationVariantVersionService,
        private productCertificationService: ProductCertificationService,
        private userService: UserService,
        private titleService: Title,
        private datepipe: DatePipe,
        private cd: ChangeDetectorRef,
        public dialogService: DialogService,
        private issuerCatalogueApi: IssuerCertificationCatalogueApiService
    ) {
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
        //Reroutes to marketplace if the user is not a member of the organisation
        if (
            !this.userService.currentMemberships.find(
                (orga) =>
                    orga.organisationId ===
                    this.organisationService.activeItem.organisationId
            ) &&
            !this.userService.isCurrentUserPlatformAdmin()
        ) {
            this.router.navigateByUrl('/marktplatz');
        }
    }

    private decodeValue(val: string): any {
        if (!val) return val;

        const isJwt = (s: any) => typeof s === 'string' && s.startsWith('eyJ') && s.split('.').length === 3;
        const decode = (token: string): any => {
            try {
                const parts = token.split('.');
                // Base64Url to Base64
                let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
                // Pad if necessary
                while (base64.length % 4 !== 0) {
                    base64 += '=';
                }
                const payload = JSON.parse(atob(base64));

                // Gaia-X/W3C VC: Check for nested JWTs in verifiableCredential array
                // The user says "the vcJWT consist of 3 VCJWT", which usually means they are inside the VP
                if (payload.vp && Array.isArray(payload.vp.verifiableCredential)) {
                    payload.vp.verifiableCredential = payload.vp.verifiableCredential.map(vc => isJwt(vc) ? decode(vc) : vc);
                } else if (Array.isArray(payload.verifiableCredential)) {
                    payload.verifiableCredential = payload.verifiableCredential.map(vc => isJwt(vc) ? decode(vc) : vc);
                }

                return payload;
            } catch {
                return token;
            }
        };

        // Try to parse as JSON first
        try {
            const parsed = JSON.parse(val);

            // If it's an array of strings, check if they are JWTs
            if (Array.isArray(parsed)) {
                return parsed.map(item => isJwt(item) ? decode(item) : item);
            }

            // Check if the object itself has a property containing a JWT (e.g., { "vcJwt": "..." })
            if (parsed && typeof parsed === 'object') {
                const jwtKeys = ['vcJwt', 'vc-jwt', 'vc_jwt', 'jwt'];
                jwtKeys.forEach(key => {
                    if (isJwt(parsed[key])) {
                        parsed[key] = decode(parsed[key]);
                    }
                });
            }

            if (isJwt(parsed)) return decode(parsed);
            return parsed;
        } catch {
            // If it's not JSON, check if it's a single JWT or multiple space-separated JWTs
            if (isJwt(val)) return decode(val);

            // Handle space-separated tokens
            const tokens = val.trim().split(/\s+/);
            if (tokens.length > 1 && tokens.every(isJwt)) {
                return tokens.map(decode);
            }

            return val;
        }
    }

    async ngOnInit() {
        this.certType = this.certificationService.activeItem.certificationType;
        if (this.certType == 'ONTOLOGY_CERT') {
            this.certShape = this.certificationVariantVersionService.activeItem.shape;
            this.titleService.setTitle(
                this.certificationVariantService.activeItem.name +
                ': Unternehmen zertifizieren - BIMSWARM'
            );
            if (this.certificationService.activeItem.issuerManaged) {
                await this.loadIssuerWorkflow(true);
                return;
            }
            await this.organisationService
                .getMinimalOrganisationList()
                .subscribe((res: OrganisationMinimalInterface[]) => {
                    this.orgaList = res;
                });
            this.certificationVariantVersionService
                .getCertifiedOrganisationsForOntology(
                    this.certificationService.activeItem.id,
                    this.certificationVariantService.activeItem.id,
                    this.certificationVariantVersionService.activeItem.id
                )
                .subscribe((res: OrganisationOntologyOverviewInterface[]) => {
                    this.certifiedOrganisationsForOntology = res;
                    res.forEach(element => {
                        element.valuesJson = this.decodeValue(element.valuesJson);
                    });
                    this.cd.detectChanges();
                });
        } else {
            await this.organisationService
                .getMinimalOrganisationList()
                .subscribe((res: OrganisationMinimalInterface[]) => {
                    this.orgaList = res;
                });
            await this.productCertificationService
                .getCertifiedProducts(
                    this.certificationVariantVersionService.activeItem.id
                )
                .subscribe((res: ProductCertificationOverview[]) => {
                    this.certifiedProductPage = res;
                    this.cd.detectChanges();
                });
            await this.certificationVariantVersionService
                .getNonListedProductCertificationForCertVar(
                    this.certificationService.activeItem.id,
                    this.certificationVariantService.activeItem.id
                )
                .subscribe((result: ProductCertificationOverview[]) => {
                    this.certifiedNonListedProductPage = result;
                    this.cd.detectChanges();
                });

            this.titleService.setTitle(
                this.certificationVariantService.activeItem.name +
                ': Produkte zertifizieren - BIMSWARM'
            );
        }
    }

    openOntologyValuesDialog(row: OrganisationOntologyOverviewInterface) {
        this.dialogService.openJSONDialog(row);
    }

    showRevocationReason(row: OrganisationOntologyOverviewInterface) {
        this.dialogService.openWiderInfoDialog('Grund für das Zurückziehen', row.revocationReason);
    }

    revokeCert(row: any) {
        const dialogRef = this.dialogService.openRevokeCertificationDialog({
            certName: this.certificationVariantService.activeItem.name,
            holderName: row.organisationName || row.organisation,
            issuanceDate: row.createdAt || row.lastCertified
        });

        dialogRef.afterClosed().subscribe(reason => {
            if (reason) {
                const loadingDialog = this.dialogService.openFileUploadLoadingDialog('Zertifikat wird zurückgezogen...');
                this.certificationVariantVersionService.revokeCertification(row.id, reason).subscribe({
                    next: () => {
                        loadingDialog.close();
                        this.dialogService.openDialog('Erfolgreich', 'Das Zertifikat wurde erfolgreich zurückgezogen.');
                        if (this.certType === 'ONTOLOGY_CERT') {
                            this.refreshCertifiedOrganisations();
                        } else {
                            this.loadTableData();
                            // Also refresh the certified product page if needed
                            this.ngOnInit();
                        }
                    },
                    error: (err) => {
                        loadingDialog.close();
                        this.dialogService.openDialog('Fehler', 'Zurückziehen fehlgeschlagen: ' + (err.message || err));
                    }
                });
            }
        });
    }

    reverseRevocation(row: OrganisationOntologyOverviewInterface) {
        this.certificationVariantVersionService.reverseRevocation(row.id).subscribe({
            next: () => {
                this.dialogService.openDialog('Erfolgreich', 'Die Zertifizierung wurde wiederhergestellt.');
                this.refreshCertifiedOrganisations();
            },
            error: (err) => {
                this.dialogService.openDialog('Fehler', 'Wiederherstellung fehlgeschlagen: ' + err.message);
            }
        });
    }

    refreshCertifiedOrganisations() {
        this.certificationVariantVersionService
            .getCertifiedOrganisationsForOntology(
                this.certificationService.activeItem.id,
                this.certificationVariantService.activeItem.id,
                this.certificationVariantVersionService.activeItem.id
            )
            .subscribe((res: OrganisationOntologyOverviewInterface[]) => {
                this.certifiedOrganisationsForOntology = res;
                res.forEach(element => {
                    element.valuesJson = this.decodeValue(element.valuesJson);
                });
                this.cd.detectChanges();
            });
    }

    commitCertificationProcess() {
        // create key-value pair array from the productversionid and whether it has the certification
        let anythingChanged: boolean = false;
        let productCertifications: ProductCertificationUpdateInterface[] = [];

        this.overviewList.forEach((overview: ProductCertificationOverview) => {
            if (overview.localChanged) {
                this.selectedProduct = overview.productId;
                anythingChanged = true;
                productCertifications.push(
                    this.buildProductCertificationUpdate(overview, false)
                );
            }
        });
        if (this.productCertificationUpdateList.length > 0) {
            this.certificationVariantVersionService.updateProductCertifications(
                this.selectedProduct,
                this.certificationService.activeItem.id,
                this.productCertificationUpdateList
            );
        }
        if (anythingChanged) {
            this.certificationVariantVersionService.updateProductCertifications(
                this.selectedProduct,
                this.certificationService.activeItem.id,
                productCertifications
            );
        }

        //Route back
        this.cancelCertificationProcess();
    }

    cancelCertificationProcess() {
        this.cancelNonListedProductCertification(true);
        this.router.navigateByUrl(
            '/organisations/' +
            this.organisationService.activeItem.organisationId +
            '/certifications/' +
            this.certificationService.activeCertification.id +
            '/variants/' +
            this.certificationVariantService.activeItem.id
        );
    }

    onCertificateValuesChange(json: string) {
        this.certificateValuesJson = json;
    }

    public get issuerManaged(): boolean {
        return Boolean(this.certificationService.activeItem?.issuerManaged);
    }

    public get canManageIssuerCertification(): boolean {
        return this.userService.isUserAdminOfOrganisationOrPlattformAdmin(
            this.organisationService.activeItem.organisationId
        );
    }

    public async commitIssuerAttestation(): Promise<void> {
        if (!this.canManageIssuerCertification || !this.selectedOrganisation) {
            return;
        }
        const organisation = this.issuerOrganisations.find(
            (candidate) =>
                candidate.organisationId === this.selectedOrganisation
        );
        const participantContextId =
            this.certificationService.activeItem.issuerParticipantContextId;
        const credentialDefinitionId =
            this.certificationService.activeItem.issuerCredentialDefinitionId;
        if (
            !organisation?.organisationId ||
            !organisation.organisationName ||
            !participantContextId ||
            !credentialDefinitionId
        ) {
            return;
        }

        let claims: JsonObject;
        try {
            claims = this.organisationClaims(
                organisation,
                this.parseCertificateClaims()
            );
        } catch {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Die Zertifikatswerte enthalten kein gültiges JSON.'
            );
            return;
        }

        this.issuerLoading = true;
        this.issuerError = '';
        try {
            await firstValueFrom(
                this.issuerCatalogueApi.createOrganisationAttestation(
                    participantContextId,
                    credentialDefinitionId,
                    {
                        organisationId: organisation.organisationId,
                        organisationName: organisation.organisationName,
                        organisationWebsite: organisation.website,
                        organisationDomain: organisation.domain,
                        claims
                    },
                    this.organisationService.activeItem.organisationId
                )
            );
            this.selectedOrganisation = null;
            this.certificateValuesJson = '';
            await this.loadIssuerWorkflow(true);
            this.dialogService.openDialog(
                'Speichern erfolgreich',
                'Die Attestierungskonfiguration wurde im Issuer gespeichert.'
            );
        } catch (error: any) {
            this.showIssuerError(
                error,
                'Die Attestierungskonfiguration konnte nicht gespeichert werden.'
            );
        } finally {
            this.issuerLoading = false;
        }
    }

    public async loadIssuerWorkflow(
        loadOrganisations = false
    ): Promise<void> {
        const participantContextId =
            this.certificationService.activeItem?.issuerParticipantContextId;
        const credentialDefinitionId =
            this.certificationService.activeItem?.issuerCredentialDefinitionId;
        if (!participantContextId || !credentialDefinitionId) {
            return;
        }

        this.issuerLoading = true;
        this.issuerError = '';
        try {
            this.issuerWorkflows = await firstValueFrom(
                this.issuerCatalogueApi.getOrganisationAttestations(
                    participantContextId,
                    credentialDefinitionId
                )
            );
            if (loadOrganisations && this.canManageIssuerCertification) {
                await this.organisationService.getAllOrgs();
                const assigned = new Set(
                    this.issuerWorkflows
                        .map((workflow) => workflow.organisationId)
                        .filter((id): id is number => id != null)
                );
                this.issuerOrganisations = (
                    this.organisationService.sdOrgs ?? []
                )
                    .filter(
                        (organisation) =>
                            organisation.organisationId != null &&
                            organisation.organisationName &&
                            organisation.organisationId !==
                                this.organisationService.activeItem.organisationId &&
                            !assigned.has(organisation.organisationId)
                    )
                    .sort((left, right) =>
                        (left.organisationName ?? '').localeCompare(
                            right.organisationName ?? ''
                        )
                    );
            }
        } catch (error: any) {
            this.showIssuerError(
                error,
                'Die Attestierungen und ausgestellten Zertifikate konnten nicht geladen werden.'
            );
        } finally {
            this.issuerLoading = false;
            this.cd.detectChanges();
        }
    }

    public async changeIssuerCredentialStatus(
        workflow: IssuerOrganisationAttestationWorkflow,
        action: 'revoke' | 'suspend' | 'resume'
    ): Promise<void> {
        if (
            !this.canManageIssuerCertification ||
            !workflow.trackedCredentialId
        ) {
            return;
        }
        const participantContextId =
            this.certificationService.activeItem.issuerParticipantContextId;
        if (!participantContextId) {
            return;
        }
        const reason = action === 'resume'
            ? undefined
            : await firstValueFrom(
                this.dialogService
                    .openRevokeCertificationDialog({
                        certName:
                            this.certificationService.activeItem.name,
                        holderName:
                            workflow.organisationName ??
                            workflow.holderId ??
                            'Organisation',
                        issuanceDate:
                            workflow.issuedAt ??
                            workflow.createdAt ??
                            new Date().toISOString(),
                        action
                    })
                    .afterClosed()
            );
        if (action !== 'resume' && !reason?.trim()) return;

        this.issuerLoading = true;
        try {
            await firstValueFrom(
                this.issuerCatalogueApi.updateCredentialStatus(
                    participantContextId,
                    workflow.trackedCredentialId,
                    action,
                    this.organisationService.activeItem.organisationId,
                    reason
                )
            );
            await this.loadIssuerWorkflow(false);
        } catch (error: any) {
            this.showIssuerError(
                error,
                'Der Zertifikatsstatus konnte nicht geändert werden.'
            );
        } finally {
            this.issuerLoading = false;
        }
    }

    public issuerStatusClass(status: CredentialLifecycleStatus): string {
        return `issuer-status-${status.toLowerCase()}`;
    }

    public issuerWorkflowReason(
        workflow: IssuerOrganisationAttestationWorkflow
    ): string {
        return workflow.revocationReason || workflow.suspensionReason || '–';
    }

    public openIssuerValuesDialog(
        workflow: IssuerOrganisationAttestationWorkflow
    ): void {
        this.dialogService.openJSONDialog({
            organisationName: workflow.organisationName ?? 'Organisation',
            valuesJson: JSON.stringify(workflow.claims ?? {}, null, 2)
        });
    }

    private parseCertificateClaims(): JsonObject {
        if (!this.certificateValuesJson) {
            return {};
        }
        const parsed = JSON.parse(this.certificateValuesJson) as JsonValue;
        if (Array.isArray(parsed)) {
            return this.valueNodesToObject(
                parsed as unknown as CertificateValueNode[]
            );
        }
        if (parsed && typeof parsed === 'object') {
            return parsed as JsonObject;
        }
        throw new Error('Certificate values must be a JSON object or array.');
    }

    private valueNodesToObject(nodes: CertificateValueNode[]): JsonObject {
        return nodes.reduce((claims, node) => {
            claims[node.name] = node.children?.length
                ? this.valueNodesToObject(node.children)
                : node.value ?? '';
            return claims;
        }, {} as JsonObject);
    }

    private organisationClaims(
        organisation: OrganisationInterface,
        formClaims: JsonObject
    ): JsonObject {
        const claims: JsonObject = {
            ...formClaims,
            bimswarmOrganisationId: organisation.organisationId
        };
        if (claims['legalName'] == null) {
            claims['legalName'] = organisation.organisationName ?? '';
        }
        if (organisation.website && claims['website'] == null) {
            claims['website'] = organisation.website;
        }
        if (organisation.domain && claims['domain'] == null) {
            claims['domain'] = organisation.domain;
        }
        return claims;
    }

    private showIssuerError(error: any, fallback: string): void {
        this.issuerError =
            error?.error?.message ??
            error?.error?.error ??
            error?.message ??
            fallback;
    }

    commitOntologyCertificationProcess() {
        // Basic guard checks
        if (!this.selectedOrganisation) {
            // optionally show a toast/snackbar
            console.warn('No organisation selected for ontology certification.');
            return;
        }

        if (!this.certificateValuesJson || this.certificateValuesJson.trim() === '[]') {
            // you might want to force at least something filled in
            console.warn('No ontology certificate values filled.');
            // optionally still allow saving if empty is valid
            // return;
        }

        // Build request payload for organisation certification
        const payload = {
            organisationId: this.selectedOrganisation,

            valuesJson: JSON.parse(this.certificateValuesJson) // array of CertificateValueNode[]
        };

        // Call your organisation certification endpoint
        // You can either reuse an existing service or create a dedicated one.
        this.certificationVariantVersionService
            .createOrUpdateOrganisationOntologyCertification(
                payload,
                this.certificationService.activeItem.id,
                this.certificationVariantService.activeItem.id,
                this.certificationVariantVersionService.activeItem.id,
            )
            .subscribe({
                next: () => {
                    this.dialogService.openDialog(
                        'Speichern erfolgreich',
                        'Die Zertifizierung wurde erfolgreich gespeichert.'
                    );
                    this.cancelCertificationProcess();
                },
                error: (err) => {
                    this.dialogService.openDialog(
                        'Speichern fehlgeschlagen',
                        err
                    );
                }
            });
    }


    ngOnDestroy(): void {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
    }

    private buildProductCertificationUpdate(
        overview: ProductCertificationOverview,
        hasDateChanged: boolean
    ): ProductCertificationUpdateInterface {
        let productCertification: ProductCertificationUpdateInterface = {
            versionId: overview.versionId,
            hasCert: overview.hasCertification,
            hasDateChanged: hasDateChanged,
            newDate: overview.lastCertified
        };
        return productCertification;
    }

    toggleCertification(overview: ProductCertificationOverview) {
        overview.hasCertification = !overview.hasCertification;
    }

    updateProductCertificationDateValue(
        date: Date,
        overview: ProductCertificationOverview
    ) {
        overview.lastCertified = this.datepipe.transform(date, 'yyyy-MM-dd');
        overview.hasDateChanged = true;
        overview.hasCertification = false;

        this.productCertificationUpdateList.push(
            this.buildProductCertificationUpdate(overview, true)
        );
    }

    public localChange(overview: ProductCertificationOverview) {
        overview.localChanged = !overview.localChanged;
    }

    async loadTableData() {
        await this.productCertificationService
            .getProductCertificationOverviews(
                this.certificationVariantVersionService.activeItem.id,
                this.selectedOrganisation
            )
            .subscribe((res: ProductCertificationOverview[]) => {
                this.overviewList = [];
                this.overviewList = res;
                this.overviewList.forEach(
                    (overview: ProductCertificationOverview) => {
                        overview.localChanged = false;
                    }
                );
            });
    }

    /**
     * find a user in the organisation with the role of an admin
     */
    findEmail(orgaId: number): Number {
        if (orgaId !== null) {
            this.organisationService.getItem(orgaId).then((selectedOrga) => {
                selectedOrga.organisationMembers.forEach((member) => {
                    if (member.role === 'ADMIN') {
                        this.emailofOrga = member.userName;
                        return;
                    }
                });
            });
        }
        return orgaId;
    }

    /**
     * handling of information put into product certification field
     * if all information is correct => send to backend to create a db entry
     */
    submitNonListedProductCertification(): void {
        if (this.orgaName === undefined) {
            this.undefinedVariable =
                'Es wurde kein Organisationsname angegeben.';
            this.error = true;
            return;
        } else if (this.productname === undefined) {
            this.undefinedVariable = 'Es wurde kein Produkt angegeben.';
            this.error = true;
            return;
        } else if (this.productVariant == undefined) {
            this.undefinedVariable = 'Es wurde keine Variante angegeben.';
            this.error = true;
            return;
        } else if (this.productVariantVersion === undefined) {
            this.undefinedVariable =
                'Es wurde keine Varianten Version angegeben.';
            this.error = true;
            return;
        } else if (!this.validateEmail(this.emailofOrga)) {
            this.undefinedVariable =
                'Es wurde entweder keine E-Mail Adresse angegeben oder die E-Mail Adresse ist nicht korrekt.';
            this.error = true;
            return;
        } else if (this.prodType === undefined) {
            this.undefinedVariable = 'Es wurde kein Produkttyp angegeben';
            this.error = true;
            return;
        }

        this.error = false;

        this.certificationVariantVersionService.createProductCertificationForNotRegistratedProducts(
            this.certificationService.activeItem.id,
            this.orgaName,
            this.productname,
            this.emailofOrga,
            this.productVariant,
            this.productVariantVersion,
            this.prodType.toString()
        );

        this.cancelNonListedProductCertification(true);
    }

    /**
     * used for the toggle if a organisation is already on the plattform if eraseAll is false
     * oth. it is used by pressing the "cancel" button so the values aren't stored in the variables.
     * @param deleteAll
     */
    cancelNonListedProductCertification(eraseAll: boolean): void {
        this.orgaName = null;
        this.productname = null;
        this.productVariant = null;
        this.productVariantVersion = null;
        this.emailofOrga = null;
        if (eraseAll) {
            this.showNonListedProdCert = false;
        }
    }

    showNonListedProdCertOptions(): void {
        this.error = false;

        this.showNonListedProdCert = true;
    }

    validateEmail(email: string): boolean {
        var emailPattern = /[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/g;
        return emailPattern.test(email);
    }
}
